import { CheckboxStyles } from '../checkbox-styles';

export abstract class CheckboxModel implements CheckboxStyles {
  formControlName?: string;
  id?: string;
  label?: string;
  innerHTML?: string;
  requiredTrue?: boolean;
  checkBoxAlignment?: 'left' | 'right' | null;

  color?: string;
  checkboxSize?: number;
  fontWeight?: number;
  fontFamily?: string;
  fontSize?: string;
}
